import React from "react";
import {
  Apple, Mountain, Circle, CircleDollarSign, Leaf, Sailboat, Key,
  Fish, Waves, Rabbit, Sun, Bird, Trees, Cat, Snowflake, Star,
} from "lucide-react";

const MAP = {
  apple: Apple, mountain: Mountain, circle: Circle, "circle-dollar-sign": CircleDollarSign,
  leaf: Leaf, sailboat: Sailboat, key: Key, fish: Fish, waves: Waves, rabbit: Rabbit,
  sun: Sun, bird: Bird, trees: Trees, cat: Cat, snowflake: Snowflake, star: Star,
};

export default function EngineIcon({ name, ...props }) {
  const Cmp = MAP[name] || Star;
  return <Cmp {...props} />;
}
